import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FiltersState {
  searchQuery: string;
  dateRange: {
    start: string | null;
    end: string | null;
  };
  sources: string[];
  changeTypes: string[];
  legislationTypes: string[];
  /** Chaves aceitas pelo GET /changes (ex.: published_at, detected_at, agency). */
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  page: number;
  pageSize: number;
}

const initialState: FiltersState = {
  searchQuery: '',
  dateRange: {
    start: null,
    end: null,
  },
  sources: [],
  changeTypes: [],
  legislationTypes: [],
  sortBy: 'published_at',
  sortOrder: 'desc',
  page: 1,
  pageSize: 25,
};

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
      state.page = 1; // Reset to first page when searching
    },
    setDateRange: (state, action: PayloadAction<{ start: string | null; end: string | null }>) => {
      state.dateRange = action.payload;
      state.page = 1;
    },
    setSources: (state, action: PayloadAction<string[]>) => {
      state.sources = action.payload;
      state.page = 1;
    },
    setChangeTypes: (state, action: PayloadAction<string[]>) => {
      state.changeTypes = action.payload;
      state.page = 1;
    },
    setLegislationTypes: (state, action: PayloadAction<string[]>) => {
      state.legislationTypes = action.payload;
      state.page = 1;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
      state.page = 1;
    },
    setSortOrder: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sortOrder = action.payload;
      state.page = 1;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
      state.page = 1;
    },
    resetFilters: (state) => {
      return { ...initialState };
    },
    updateFilters: (state, action: PayloadAction<Partial<FiltersState>>) => {
      return { ...state, ...action.payload, page: 1 };
    },
  },
});

export const {
  setSearchQuery,
  setDateRange,
  setSources,
  setChangeTypes,
  setLegislationTypes,
  setSortBy,
  setSortOrder,
  setPage,
  setPageSize,
  resetFilters,
  updateFilters,
} = filtersSlice.actions;
